import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { useGSAP } from '@gsap/react';

// Registration happens once, at module load. Every file that animates should
// import gsap from here rather than from the package directly.
gsap.registerPlugin(ScrollTrigger, SplitText, useGSAP);

/*
  Mobile browsers fire `resize` every time the URL bar collapses or expands
  during a scroll. Left alone, ScrollTrigger refreshes on each of those, which
  recalculates every start/end and nudges the scroll position — the page appears
  to jump back up a little mid-scroll. `ignoreMobileResize` makes ScrollTrigger
  skip a refresh when only the viewport *height* changed, which is exactly the
  URL-bar case; a genuine rotation still changes the width and still refreshes.
*/
ScrollTrigger.config({ ignoreMobileResize: true });

// Matches the entrance curve already used by the CSS `.enter` classes.
export const EASE = 'power3.out';
// A longer, more deliberate curve for the hero and for masked line reveals.
export const EASE_DISPLAY = 'power4.out';

export const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export { gsap, ScrollTrigger, SplitText, useGSAP };
